var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#88C648",
    d: "M17.3 0H3.33v13.91h5.35c.43 4.96-2.5 8-8.46 8.61L1.34 28c10.27-.17 15.96-4.78 15.96-16.26zm21.92 0H25.24v13.91h5.35c.43 4.96-2.5 8-8.45 8.61L23.26 28c10.27-.17 15.96-4.78 15.96-16.26z"
  })));
};
export default SvgQuote;